import {AnimatePresence, motion} from 'framer-motion';
import {useState, useEffect} from 'react';
import globalDomains from '@/utils/global-domains';
import styles from './styles.module.css';

const SoopiResizeScrollButton = ({
  height,
  setHeight,
  isResizing,
  setIsResizing,
}) => {
  const [startY, setStartY] = useState(0);
  const [isHover, setIsHover] = useState(false);

  const handleMouseDown = (e) => {
    setStartY(e.clientY);
    setIsResizing(true);
  };

  const handleMouseMove = (e) => {
    if (!isResizing) return;
    document.body.style.WebkitUserSelect = 'none';
    const deltaY = startY - e.clientY;
    let newHeight = height + deltaY;
    const viewportHeight = window.innerHeight - 94;

    // 경계값 적용
    if (newHeight < 400) {
      newHeight = 400;
    } else if (newHeight > viewportHeight) {
      newHeight = viewportHeight;
    }

    // 높이가 변경된 경우에만 업데이트
    if (newHeight !== height) {
      setHeight(newHeight);
      setStartY(e.clientY);
    }
  };

  const handleMouseUp = () => {
    setIsResizing(false);
    document.body.style.WebkitUserSelect = '';
  };

  useEffect(() => {
    const message = JSON.stringify({
      type: 'soopi_height',
      value: height,
    });

    const frame = document.getElementById('soopi-frame');
    if (frame && frame.contentWindow) {
      frame.contentWindow.postMessage(
        message,
        `${globalDomains.SOOPI_AFREECATV}`,
      );
    }
  }, [height]);

  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  // 창 크기 변경 시 높이 조정
  useEffect(() => {
    const handleResize = () => {
      const viewportHeight = window.innerHeight - 94;

      if (viewportHeight < 400) {
        setHeight(400);
      } else if (height > viewportHeight) {
        setHeight(viewportHeight);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [height, setHeight]);

  return (
    <>
      {isResizing && <div className={styles.overlay} />}
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={{
          position: 'absolute',
          height: 20,
          width: '100%',
          top: 0,
        }}>
        <AnimatePresence>
          {isHover && (
            <motion.div
              initial={{opacity: 0}}
              animate={{opacity: 1, transition: {duration: 0.2}}}
              onMouseDown={handleMouseDown}
              style={{
                width: '100%',
                height: 20,
                position: 'absolute',
                top: 0,
                cursor: 'row-resize',
                userSelect: 'none',
              }}
            />
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default SoopiResizeScrollButton;
